import React from "react";
import styled from "styled-components";
import { useLocation } from "react-router-dom";

const BreadcrumbContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 20px 0;
  padding: 0 20px;
`;

const BreadcrumbItem = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border-radius: 16px;
  background-color: ${props => (props.isActive || props.isCompleted) ? '#FF6D1D' : '#E0E0E0'};
  color: ${props => (props.isActive || props.isCompleted) ? '#FFFFFF' : '#757575'};
  font-size: 14px;
  font-weight: 600;
  position: relative;
  z-index: 2;
`;

const ConnectingLine = styled.div`
  height: 2px;
  width: 40px;
  background-color: ${props => props.isCompleted ? '#FF6D1D' : '#E0E0E0'};
  position: relative;
  z-index: 1;
`;

const BondSubBreadcrumb = () => {
  const location = useLocation();
  
  // Map route paths to panel numbers
  const routeToPanelMap = {
    "/bond/principal": 1,
    "/bond/obligee": 2,
    "/bond/bid": 3,
    "/bond/penality": 4,
    "/bond/bond": 5,
    "/bond/job-cost-breakdown": 6,
    "/bond/subcontractor": 7,
    "/bond/remarks": 8,
  };

  // Get current panel from route
  const getCurrentPanel = () => {
    const path = location.pathname.replace("/prequalify", "");
    return routeToPanelMap[path] || 1;
  };

  const currentPanel = getCurrentPanel();
  const totalPanels = 8;

  // Only show if we're on a bond route
  if (!location.pathname.includes("/bond")) {
    return null;
  }

  return (
    <BreadcrumbContainer>
      {Array.from({ length: totalPanels }, (_, index) => {
        const panelNumber = index + 1;
        const isActive = panelNumber === currentPanel;
        const isCompleted = panelNumber < currentPanel;
        
        return (
          <React.Fragment key={panelNumber}>
            <BreadcrumbItem isActive={isActive} isCompleted={isCompleted}>
              {panelNumber}
            </BreadcrumbItem>
            {panelNumber < totalPanels && (
              <ConnectingLine isCompleted={isCompleted} />
            )}
          </React.Fragment>
        );
      })}
    </BreadcrumbContainer>
  );
};

export default BondSubBreadcrumb; 